import { Alert } from '@blueprintjs/core'
import React from 'react'
import { animated } from 'react-spring'
import { Spring } from 'react-spring/renderprops-universal'

const AnimatedAlert = ({ type, children, style }) => (
  <Spring native={true} from={{ t: 0 }} to={{ t: 1 }}>
    {({ t }) => {
      const transform = t.interpolate({
        range: [0, 1],
        output: ['scale(0.95)', 'scale(1)'],
      })

      return (
        <animated.div style={{ transform, WebkitTransform: transform }}>
          <Alert bsStyle={type} style={style}>
            {children}
          </Alert>
        </animated.div>
      )
    }}
  </Spring>
)

export default AnimatedAlert
